/**
 * @desc 根据shopcodeList获取交易主体信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/ordercompany/getPlatformSiteShopByShopCodeList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
